<template>
  <section class="px-14 pb-6 mt-4 sm-max:px-5" :class="sectionClass" :style="{ maxWidth: maxWidth + 'px' }">
    <div class="mt-16 space-y-5 sm-max:mt-0 md-max:pt-0 custom-mt-lg">
      <div class="text-base leading-5 lg:text-21 md:text-lg lg:leading-7" :class="newStyle ? 'md-max:text-xl' : ''"
        v-html="text6"></div>
      <div class="text-base lg:text-21 md:text-lg" v-html="text7" :class="newStyle ? 'md-max:text-xl' : ''"></div>
      <div class="!mt-3 lg:text-21 md:text-lg text-base lg:leading-7 leading-5" :class="newStyle ? 'md-max:text-xl' : ''"
        v-html="text8"></div>
    </div>
  </section>
</template>

<script setup>

const props = defineProps({
  text6: {
    type: String,
    default: 'What I’ve found is that regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor.',
  },
  text7: {
    type: String,
    default: 'The best tasting coffee, it turns out, is also the healthiest coffee.',
  },
  text8: {
    type: String,
    default: 'The coffee I’ve found is delicious and is the cleanest, purest, healthiest coffee I’ve ever seen.',
  },


  buttonText: {
    type: String,
    default: 'Save 50% Now',
  },
  sectionClass: {
    type: String,
    default: '',
  },
  maxWidth: {
    type: String,
    default: '',
  },
  newStyle: {
    type: Boolean,
    default: false
  }
})

defineBuilderComponent({
  friendlyName: "AboutText",
  canHaveChildren: true,
  inputs: [
    {
      name: "text6",
      type: "richText",
      defaultValue: "What I’ve found is that regular mass-produced, blended coffee is loaded with chemicals and additives that destroy the flavor."
    },
    {
      name: "text7",
      type: "richText",
      defaultValue: "The best tasting coffee, it turns out, is also the healthiest coffee."
    },
    {
      name: "text8",
      type: "richText",
      defaultValue: "The coffee I’ve found is delicious and is the cleanest, purest, healthiest coffee I’ve ever seen."
    },
    {
      name: "sectionClass",
      type: "text",
      defaultValue: ""
    },
    {
      name: "maxWidth",
      type: "text",
      defaultValue: ""
    },
    {
      name: "newStyle",
      type: "boolean",
      defaultValue: false
    }
  ]
});
</script>